import { useContext, } from 'react';
import { useTheme, } from '@mui/material/styles';
import { IconButton, Stack, Tooltip, } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { ColorModeContext, } from '../../hoc/context/ColorModeContext';
import { useMathcesDown, } from '../../hooks';
import CustomLink from '../custom-link';

const authButtons = [
    { name: 'Войти', link: '/login', icon: LoginIcon, },
    { name: 'Регистрация', link: '/signup', icon: PersonAddAlt1Icon, },
];

export default function AuthButtons() {
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    const matchesMd = useMathcesDown('md');
    const matchesLg = useMathcesDown('lg');

    return (
        <Stack
            direction='row'
            spacing={ matchesLg ? 1 : 2 }>
            <Tooltip title={(theme.palette.mode === 'dark') ? 'Установить светлый режим' : 'Установить тёмный режим'} placement='bottom' arrow>
                <IconButton onClick={colorMode.toggleColorMode} sx={{
                    mt: 0.25,
                    mr: {
                        xs: 0.5,
                        lg: 0,
                    },
                    p: 0,
                    '& .MuiSvgIcon-root': {
                        color: 'text.primary',
                    },
                }}>
                    { theme.palette.mode === 'light' ? <DarkModeOutlinedIcon sx={{ fontSize: [24, 26, 28], }} /> : <DarkModeIcon sx={{ fontSize: [24, 26, 28], }} /> }
                </IconButton>
            </Tooltip>
            {
                authButtons.map((button) => {
                    return (
                        <CustomLink
                            key={button.name}
                            variant='btn'
                            to={button.link}
                            sx={{
                                border: 1,
                                borderColor: 'borderColor.main',
                                color: 'text.primary',
                                fontSize: 15,
                                justifyContent: 'flex-start',
                                padding: {
                                    md: '6px 10px',
                                    lg: '6px 12px',
                                },
                            '&:hover': {
                                borderColor: 'secondary.main',
                                color: 'secondary.main',
                            },
                        }}>
                            <button.icon
                                sx={{
                                    fontSize: [19, 21, 23, 22],
                                    mr: {
                                        md: 1,
                                    },
                                }} />
                            {!matchesMd && button.name}
                        </CustomLink>
                    );
                })
            }
        </Stack>
    );
}